
import { connect } from 'react-redux';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { arreglo, secondsToString, mapStateToProps, forMiles, puntoPorComa  } from "../../funtComponents/models/buscar";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
//



 function TablaCombinados (props) {
  const resueltoSalientes = arreglo(props.salientes, props.anexos); 
  const resueltoEntrantes = arreglo(props.entrantes, props.anexos); 
//
  function contarTodo(condi, resuelto2, condi2){
    let respuesta =resuelto2.flatMap((e) => {
      if(e.chan1 === condi){
        return e[condi2]
      }else{ return [] }
    });
    return respuesta
  }

  const arrUnidos = arreglo(props.entrantes, props.rightAnexos, props.salientes)

  
  return (
    <TableContainer component={Paper}>
      <Table sx={{ maxWidth: '100%' }} aria-label="customized table">
        <TableHead>
          <TableRow >
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', fontWeight: 600 }}>
            Usuario
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Total
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Entrantes
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Salientes
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Completadas
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Fallidas
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            % Fallidas
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Duracion
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            % Duracion
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Promedio Duracion
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Total Ring Time
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Promedio Ring Time
            </StyledTableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {arrUnidos.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="right">{forMiles(row.cantidad)}</StyledTableCell>
              <StyledTableCell align="right">{forMiles(parseInt(contarTodo(row.chan1, resueltoEntrantes, 'cantidad')))|| 0}</StyledTableCell>
              <StyledTableCell align="right">{forMiles(parseInt(contarTodo(row.chan1, resueltoSalientes, 'cantidad'))) || 0}</StyledTableCell>
              <StyledTableCell align="right">{forMiles(parseInt(row.cantidad-row.fallidas))|| 0}</StyledTableCell>
              <StyledTableCell align="right">{forMiles(row.fallidas)}</StyledTableCell>
              <StyledTableCell align="right">{puntoPorComa(((row.fallidas*100)/(row.cantidad)).toFixed(0)) || 0 +'%'}</StyledTableCell>
              <StyledTableCell align="right">{secondsToString(row.duration) || 0}</StyledTableCell>
              <StyledTableCell align="right">{puntoPorComa((((parseFloat(row.duration)-parseFloat(row.ring))*100)/(row.duration-parseFloat(row.ring))).toFixed(0)) || 0 +'%'}</StyledTableCell>
              <StyledTableCell align="right">{secondsToString(((row.billsec)/(row.cantidad))) || 0}</StyledTableCell>
              <StyledTableCell align="right">{secondsToString(row.ring) || 0}</StyledTableCell>
              <StyledTableCell align="right">{secondsToString((row.ring)/row.cantidad) || 0}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

}

export default connect(mapStateToProps, null)(TablaCombinados);
